'use client';
type Props = {
  state: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  height?: number;
};

const Switch = (props: Props) => {
  const clickHandler = () => {
    if (props.disabled) return;
    props.onChange(!props.state);
  };

  return (
    <div
      onClick={clickHandler}
      className={`relative flex cursor-pointer rounded-2xl bg-background-light align-middle 
        ${props.state ? 'bg-primary' : ''} ${props.disabled ? 'cursor-not-allowed' : ''}`}
      style={{
        height: props.height || '26px',
        width: props.height ? `${props.height * 1.69}px` : '44px',
        minWidth: props.height ? `${props.height * 1.69}px` : '44px'
      }}
    >
      <div
        className={`absolute left-0 mx-1 mb-0 mt-[3px] rounded-full bg-white transition-all duration-200 ease-in-out 
          ${props.state ? 'translate-x-4' : ''} ${props.disabled ? 'cursor-not-allowed' : ''}`}
        style={{
          height: props.height ? `${props.height / 1.3}px` : '20px',
          width: props.height ? `${props.height / 1.3}px` : '20px'
        }}
      />
    </div>
  );
};

export default Switch;
